import React from 'react';
import PropTypes from 'prop-types';

const CustomButton = ({
	onClick = () => {},
	mainText = '',
	color = 'light-primary',
	outlined = false,
	style = {},
	disabled = false,
	loading = false,
	className = '',
	icon: Icon,
}) => {
	const buttonStyle = {
		cursor: disabled ? 'not-allowed' : 'pointer',
		...style,
	};
	return (
		<button
			className={`btn ${outlined ? `btn-outline-${color}` : `btn-${color}`} ${
				disabled ? 'disabled' : ''
			} ${className}`}
			style={buttonStyle}
			disabled={disabled}
			onClick={() => onClick()}
		>
			{Icon && (
				<Icon data-testid={`button-${mainText.toLowerCase().replace(/ /g, '-')}`} />
			)}
			{'  '}
			<span>{mainText}</span>
			{loading && (
				<span
					style={{ paddingLeft: '15px' }}
					className="ml-3 spinner spinner-white"
				></span>
			)}
		</button>
	);
};

CustomButton.propTypes = {
	onClick: PropTypes.func,
	mainText: PropTypes.node,
	color: PropTypes.string,
	style: PropTypes.object,
};

export default CustomButton;
